module.exports = __webpack_public_path__ + "img/IMG_0216.ba0bc2a2.jpg";